import api from './utilBackoffice';

const controller = 'EventoContabil';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => {
    return api.Axios.GetParams(url, dto);
  },
  ListarEventosContabeis: dto => {
    return api.Axios.GetParams(url + '/ListarEventosContabeis', dto);
  },
  ListarHistoricosByEvento: dto => {
    return api.Axios.GetParams(url + '/ListarHistoricosByEvento', dto);
  },
  Create: dto => {
    return api.Axios.Post(url, dto);
  },
  Update: dto => {
    return api.Axios.PutCommand(url, dto);
  },
  Delete: dto => {
    return api.Axios.DeleteCommand(url, dto);
  },
  ListarCadastrados: dto => {
    return api.Axios.GetParams(url + '/ListarCadastrados', dto);
  },
  ImportEventos: dto => {
    return api.Axios.Post(url + '/ImportEventos', dto);
  }
});
